/* eslint-disable no-empty-pattern */
import roundHistoryInfoService from '@/services/roundHistoryInfo.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		roundHistoryInfos: [],
		roundHistoryInfo: {},
		searchParams: {
			customerId: '',
			done: null,
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_HISTORYINFOS(state, roundHistoryInfos) {
			state.roundHistoryInfos = roundHistoryInfos;
		},
		SET_HISTORYINFO(state, roundHistoryInfo) {
			state.roundHistoryInfo = roundHistoryInfo;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getRoundHistoryInfo({ commit }, roundHistoryInfoId) {
			return await roundHistoryInfoService
				.getRoundHistoryInfo(roundHistoryInfoId)
				.then(data => {
					commit('SET_HISTORYINFO', data);
				})
				.catch(err => {
					console.log('Error getting roundHistoryInfo: ', err);
				});
		},
		async getRoundHistoryInfos({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await roundHistoryInfoService
				.getRoundHistoryInfos(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_HISTORYINFOS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getRoundHistoryInfos');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roundHistoryInfos: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createRoundHistoryInfo({ dispatch }, roundHistoryInfo) {
			return await roundHistoryInfoService
				.createRoundHistoryInfo(roundHistoryInfo)
				.then(() => {
					dispatch('getRoundHistoryInfos');
				})
				.catch(err => {
					console.log('Error creating roundHistoryInfo: ', err);
				});
		},
		async updateRoundHistoryInfo({}, roundHistoryInfo) {
			return await roundHistoryInfoService
				.updateRoundHistoryInfo(roundHistoryInfo)
				.catch(err => {
					console.log('Error updating roundHistoryInfo: ', err);
				});
		},
		async deleteRoundHistoryInfo({ dispatch }, roundHistoryInfo) {
			return await roundHistoryInfoService
				.deleteRoundHistoryInfo(roundHistoryInfo.id)
				.then(() => {
					dispatch('getRoundHistoryInfos');
				})
				.catch(err => {
					console.log('Error deleting roundHistoryInfo: ', err);
				});
		},

		setRoundHistoryInfo({ commit }, roundHistoryInfo) {
			commit('SET_HISTORYINFO', roundHistoryInfo);
		},
		setRoundHistoryInfos({ commit }, roundHistoryInfos) {
			commit('SET_HISTORYINFO', roundHistoryInfos);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		roundHistoryInfo: state => {
			return state.roundHistoryInfo;
		},
		roundHistoryInfos: state => {
			return state.roundHistoryInfos;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
